import { UserManager } from "oidc-client-ts";
import { createContext } from "react";

type AuthManger = {
  manager: UserManager;
  getUser: UserManager["getUser"];
  signinCallback: UserManager["signinCallback"];
  signinRedirect: UserManager["signinRedirect"];
  signoutRedirect: UserManager["signoutRedirect"];
  signoutCallback: UserManager["signoutCallback"];
  signinSilentCallback: UserManager["signinSilentCallback"];
};

export type AuthContextType = AuthManger;

function getManager(): AuthManger {
  const manager = new UserManager({
    authority: import.meta.env.REACT_APP_IDP_AUTHORITY,
    automaticSilentRenew: false,
    client_id: import.meta.env.REACT_APP_IDP_CLIENT_ID,
    filterProtocolClaims: true,
    loadUserInfo: true,
    monitorSession: true,
    post_logout_redirect_uri:
      window.location.origin + "/authentication/signout/",
    redirect_uri: window.location.origin + "/authentication/callback/",
    response_type: "code",
    scope: "openid profile applicationapi",
    silent_redirect_uri: window.location.origin + "/authentication/silent/",
    validateSubOnSilentRenew: true,
    extraQueryParams: {
      registrationRedirectUrl: window.location.href,
    },
  });

  // bind manager to each function we want to use so that we can use these
  // functions with use-async-resource
  return {
    manager,
    getUser: manager.getUser.bind(manager),
    signinCallback: manager.signinCallback.bind(manager),
    signinRedirect: manager.signinRedirect.bind(manager),
    signoutRedirect: manager.signoutRedirect.bind(manager),
    signoutCallback: manager.signoutCallback.bind(manager),
    signinSilentCallback: manager.signinSilentCallback.bind(manager),
  };
}

export const AuthContext = createContext(getManager());
